import { ContentItem } from '@kentico/kontent-delivery';
import get from 'lodash/get';
import { IButtonProps } from '../components/button/button';

export class ButtonModel extends ContentItem {
  get text(): string {
    return get(this._config, 'elements.text_value.value', '');
  }

  get scrollToSection(): string {
    return get(this._config, 'elements.scroll_to_section.value', '');
  }

  get boldText(): boolean {
    return get(this._config, 'elements.bold_text.value[0].codename') === 'true';
  }

  get theme(): string | null {
    return get(
      this._config,
      'elements.theme_schema__theme_type.value[0].codename',
      ''
    );
  }

  get size(): string {
    return get(this._config, 'elements.size.value[0].codename', '');
  }

  get border(): string {
    return get(this._config, 'elements.border.value[0].codename', '');
  }

  get CTA(): boolean {
    return (
      get(this._config, 'elements.call_to_action.value[0].codename') === 'true'
    );
  }

  get reversed(): boolean {
    return get(this._config, 'elements.reversed.value[0].codename') === 'true';
  }

  get transofrmUppercase(): boolean {
    return (
      get(
        this._config,
        'elements.transform_uppercase.value[0].codename',
        ''
      ) === 'true'
    );
  }

  get internalLink(): string | null {
    const pageLink = get(
      this._config,
      'elements.page.value[0].elements.basic_page_settings__url.value',
      ''
    );

    const pageCaseStudyArticle = get(
      this._config,
      'elements.pageCaseStudyArticle.value[0].elements.basic_page_settings__url.value',
      ''
    );

    const pageBlogArticle = get(
      this._config,
      'elements.pageBlogArticle.value[0].elements.basic_page_settings__url.value',
      ''
    );

    const pageContact = get(
      this._config,
      'elements.pageContact.value[0].elements.basic_page_settings__url.value',
      ''
    );

    const linksArr = [
      pageLink,
      pageCaseStudyArticle,
      pageBlogArticle,
      pageContact
    ];

    const getLink = linksArr.filter(link => link.length > 0);

    return getLink.length ? getLink[0] : null;
  }

  get externalLink(): string {
    return get(this._config, 'elements.external_link.value', '');
  }

  get downloadFile(): object {
    const file = get(this._config, 'elements.download_file.value[0]', {});
    return {
      url: get(file, 'url', ''),
      name: get(file, 'name', '')
    };
  }

  public static create(data: IButton): IButtonProps {
    const {
      text,
      boldText,
      theme,
      size,
      border,
      CTA,
      transofrmUppercase,
      reversed,
      internalLink,
      scrollToSection,
      externalLink,
      downloadFile
    } = new ButtonModel(data);
    return {
      text,
      boldText,
      theme,
      size,
      border,
      CTA,
      transofrmUppercase,
      reversed,
      internalLink,
      scrollToSection,
      externalLink,
      downloadFile
    };
  }
}
